import { render, staticRenderFns } from "./ParamsBlock.vue?vue&type=template&id=07a3db04"
import script from "./ParamsBlock.vue?vue&type=script&lang=js"
export * from "./ParamsBlock.vue?vue&type=script&lang=js"
import style0 from "./ParamsBlock.vue?vue&type=style&index=0&id=07a3db04&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports